import { vars } from "@pancakeswap/ui/css/vars.css";
import { darkColors, lightColors } from "../../theme/colors";
export var light = {
    background: "#232121",
    text: darkColors.text,
    boxShadow: vars.shadows.tooltip
};
export var dark = {
    background: "#232121",
    text: lightColors.text,
    boxShadow: vars.shadows.tooltip
};
